import { useUserSettings as libUseUserSettings } from 'use-user-settings';

export const useUserSettings = <T>(
  defaultValue: T | (() => T),
  key?: UserSettingsKeyType
) => {
  return libUseUserSettings(defaultValue, key, 'sp-outreach-ui.');
};
